import { alpha, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentLoader from '../../subcomponents/ContentLoader';
import { fetchExternalConnectionSettings } from '../adminSlice';
import AdminSettingBool from '../inputs/AdminSettingBool';
import AdminSettingHidden from '../inputs/AdminSettingHidden';
import AdminSettingText from '../inputs/AdminSettingText';

export default function MessageSettingsTab() {
    const dispatch = useDispatch();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { externalConnections } = useSelector((state) => state.admin);
    const { siomSettings, siomSettingsStatus } = useSelector((state) => state.settings.siom);

    useEffect(() => {
        dispatch(fetchExternalConnectionSettings());
    }, [dispatch]);

    return (
        <ContentLoader
            successCondition={externalConnections.status === "success" && siomSettingsStatus === "success"}
            errorCondition={externalConnections.status === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1}>
                        {/* GENERAL SETINGS */}
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.MSG_TITLE_GENERAL}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Messages_Enabled"}
                                settingDefaultValue={siomSettings?.messagesEnabled}
                                formLabel={resourceFinal[appLanguage].admin.MSG_MESSAGES}
                                formText={resourceFinal[appLanguage].admin.MSG_MESSAGES_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Bericht_SendEmail"}
                                settingDefaultValue={siomSettings?.messageSendEmail}
                                formLabel={resourceFinal[appLanguage].admin.MSG_MESSAGES_MESSAGE_SEND_EMAIL}
                                formText={resourceFinal[appLanguage].admin.MSG_MESSAGES_MESSAGE_SEND_EMAIL_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"Email_SmtpEnableSsl"}
                                settingDefaultValue={externalConnections.data?.emailSmtpEnableSsl}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_SSL}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_SSL_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"GraphAPI_Enabled"}
                                settingDefaultValue={externalConnections.data?.graphAPIEnabled}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_ENABLED}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_ENABLED_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Bericht_GebruikAlgemeenAdres"}
                                settingDefaultValue={siomSettings?.messageUseGeneralEmailAddress}
                                formLabel={resourceFinal[appLanguage].admin.MSG_MESSAGES_USE_GENERAL_EMAIL_ADDRESS}
                                formText={resourceFinal[appLanguage].admin.MSG_MESSAGES_USE_GENERAL_EMAIL_ADDRESS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_Bericht_EmailAdres"}
                                settingDefaultValue={siomSettings?.messageGeneralEmailAddress}
                                formLabel={resourceFinal[appLanguage].admin.MSG_MESSAGES_GENERAL_EMAIL_ADDRESS}
                                formText={resourceFinal[appLanguage].admin.MSG_MESSAGES_GENERAL_EMAIL_ADDRESS_HTEXT}
                                xsSize={6}
                            />
                        </Grid>
                        {/* ABSENTIE */}
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.MSG_TITLE_ABSENCE}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Email_EmailBijAfwezigheidVersturen"}
                                settingDefaultValue={siomSettings?.absenceSendMessage}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_SendEmail"}
                                settingDefaultValue={siomSettings?.absenceSendEmail}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_SEND_EMAIL}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_SEND_EMAIL_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_Onderwerp"}
                                settingDefaultValue={siomSettings?.absenceSubject}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_SUBJECT}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_SUBJECT_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_SendAppMessage"}
                                settingDefaultValue={siomSettings?.absenceSendApp}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_SEND_APP}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_SEND_APP_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_GebruikAlgemeenAdres"}
                                settingDefaultValue={siomSettings?.absenceUseGeneralEmailAddress}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_USEGENERALEMAILADDRESS}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_USEGENERALEMAILADDRESS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_EmailAdres"}
                                settingDefaultValue={siomSettings?.absenceGeneralEmailAddress}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_GENERALEMAILADDRESS}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_GENERALEMAILADDRESS_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Email_EmailBijAfwezigheidVersturenCCDocent"}
                                settingDefaultValue={siomSettings?.absenceSendCC}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_SENDCC}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_SENDCC_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={12}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_Absentiebericht_Tekst"}
                                settingDefaultValue={siomSettings?.absenceText}
                                formLabel={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_TEXT}
                                formText={resourceFinal[appLanguage].admin.MSG_ABSENCE_MSG_TEXT_HTEXT}
                                xsSize={12}
                                richTextEditor
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* EMAIL SMTP */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.MSG_TITLE_EMAIL_SMTP}</Typography>
                            </Grid>
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"Email_SmtpUsename"}
                                settingDefaultValue={externalConnections.data?.emailSmtpUsename}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_USENAME}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_USENAME_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"Email_SmtpHost"}
                                settingDefaultValue={externalConnections.data?.emailSmtpHost}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_HOST}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_HOST_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"Email_SmtpPort"}
                                settingDefaultValue={externalConnections.data?.emailSmtpPort}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PORT}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PORT_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"Email_SmtpPassword"}
                                settingDefaultValue={externalConnections.data?.emailSmtpPassword}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PASSWORD}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PASSWORD_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"Email_SmtpPassword_SendGrid"}
                                settingDefaultValue={externalConnections.data?.emailSmtpPasswordSendGrid}
                                formLabel={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PASSWORD_SENDGRID}
                                formText={resourceFinal[appLanguage].admin.MSG_EMAIL_SMTP_PASSWORD_SENDGRID_HTEXT}
                                xsSize={12}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* EMAIL SMTP */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.MSG_TITLE_GRAPH_API}</Typography>
                            </Grid>
                            <AdminSettingText
                                settingsType={"external"}
                                settingKey={"GraphAPI_Url"}
                                settingDefaultValue={externalConnections.data?.graphAPIUrl}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_URL}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_URL_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"GraphAPI_Key"}
                                settingDefaultValue={externalConnections.data?.graphAPIKey}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_KEY}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_KEY_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"GraphAPI_AzureTenantID"}
                                settingDefaultValue={externalConnections.data?.graphAPIAzureTenantID}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_AZURE_TENANT_ID}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_AZURE_TENANT_ID_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"GraphAPI_Secret"}
                                settingDefaultValue={externalConnections.data?.graphAPISecret}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_SECRET}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_SECRET_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingHidden
                                settingsType={"external"}
                                settingKey={"GraphAPI_ClientID"}
                                settingDefaultValue={externalConnections.data?.graphAPIClientID}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_CLIENT_ID}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_CLIENT_ID_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"external"}
                                settingKey={"GraphAPI_SaveToSentItems"}
                                settingDefaultValue={externalConnections.data?.graphAPISaveToSentItems}
                                formLabel={resourceFinal[appLanguage].admin.MSG_GRAPH_API_SAVE_TO_SENT_ITEMS}
                                formText={resourceFinal[appLanguage].admin.MSG_GRAPH_API_SAVE_TO_SENT_ITEMS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                        </Grid>
                    </Grid>
                </ Box>
            }
        />
    );
}